import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from "@material-ui/core";
import * as React from "react";

interface Props {
  onClose: () => void;
  open: boolean;
}

const TechnicalSupportDialog: React.FunctionComponent<Props> = ({
  open,
  onClose,
}) => (
  <Dialog open={open} maxWidth={"md"} onClose={onClose}>
    <DialogTitle>Technischer Support</DialogTitle>
    <DialogContent>
      <Typography variant="body2" gutterBottom>
        <strong>Technische Hotline:</strong>{" "}
        <Link href="tel:+4922193738777">(0221) 93738-777</Link>
        <br />
        Montags bis Freitags 9.00 bis 17.00 Uhr
      </Typography>
      <Typography variant="body2">
        E-Mail:{" "}
        <Link href="mailto:hotline@otto-schmidt.de">
          hotline@otto-schmidt.de
        </Link>
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Schließen</Button>
    </DialogActions>
  </Dialog>
);

export default TechnicalSupportDialog;
